import { initPageViewTracking } from '~/composables/pageViews';

export default defineNuxtPlugin({
  name: 'page-views',
  setup: () => {
    initPageViewTracking();
  },
});
